/* Printer */
export const GET_CLAIM = "GET_CLAIM";
export const CLAIM_RECEIVED = "CLAIM_RECEIVED";
export const CREATE_CLAIM = "CREATE_CLAIM";
export const CLAIM_CREATED = "CLAIM_CREATED";

